import SEO from "@/components/site/SEO";
import { Reveal, Eyebrow } from "@/components/site/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { FAQS } from "@/data/site";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <SEO title="Frequently Asked Questions" description="Answers about custom cushion cover quotes, measuring, fabrics, timelines and payments at Tanonshop." />

      <section className="mx-auto max-w-3xl px-5 sm:px-8 pt-20 pb-14 lg:pt-28">
        <Reveal>
          <Eyebrow>Good to know</Eyebrow>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.03]">
            Frequently asked questions
          </h1>
          <p className="mt-6 text-lg text-teal-anchor/70 leading-relaxed font-light">
            Everything about how quotes, measuring and orders work. Still unsure? The contact page is a message away.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-3xl px-5 sm:px-8 pb-24 lg:pb-32">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-teal-anchor/12">
                <AccordionTrigger className="py-6 text-left font-serif text-xl tracking-tight hover:no-underline hover:text-teal-primary">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base text-teal-anchor/70 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="mt-14 rounded-sm bg-paper-soft p-8 text-center">
          <p className="font-serif text-2xl tracking-tight">Still have a question?</p>
          <Link to="/contact" className="mt-5 inline-flex rounded-sm bg-teal-primary px-7 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-paper transition-all duration-200 hover:bg-teal-hover hover:-translate-y-px">
            Contact Us
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
